import React from 'react';
import 'core-js/features/array/at';
import { Worker, Viewer, SpecialZoomLevel } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import { useIsMobile } from '@src/utils/general';

const Pdf = ({ height, width, pdf, url }) => {
	const iframeUrl = pdf?.asset?.url || url;
	const defaultLayoutPluginInstance = defaultLayoutPlugin();
	const isMobile = useIsMobile();

	return (
		<div className="w-full flex flex-wrap flex-col md:flex-nowrap md:gap-5 rounded-xl w-full justify-center max-h-[900px]">
			<Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js`}>
				<div className={`m-auto min-w-full min-h-[600px] sm:min-w-[600px] ${width ? `w-[${width}px]` : 'w-full'} ${height ? `h-[${height}px]` : 'h-full'}`}>
					<Viewer fileUrl={iframeUrl} defaultScale={isMobile ? 0.4 : SpecialZoomLevel.PageFit} plugins={[defaultLayoutPluginInstance]} />
				</div>
			</Worker>
		</div>
	);
};

export default Pdf;
